const degree = [{
  path: 'degree/index',
  component: resolve => require(['../../../../components/pages/registerstudentpay/degree'], resolve)
}]
export default degree
